import { BCDataGrid, BCTreeList } from '@bimser/components';
import DataGrid2 from '../..';
import { ISelectionChangedEventArgs } from '../../../../entities/EventArgs';

export async function onSelectionChanged(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.SelectionChangedEvent
		| BCTreeList.Components.TreeListTypes.SelectionChangedEvent
) {
	await this.__onSelectionChanging(e);

	await this.set('selectedRowKeys', e.selectedRowKeys).set(
		'selectedRowsData',
		e.selectedRowsData
	);

	const selectionChangedEventArgs: ISelectionChangedEventArgs = {
		items: e.selectedRowsData
	};

	await this.emit('event:OnSelectionChanged', selectionChangedEventArgs);
}
